export { privacyNoticeUpdates, privacyNoticeDate } from './privacy_changes';

export const userPoolId = process.env.POOL_ID;
export const appClientId = process.env.APP_CLIENT;
export const routerMode = process.env.ROUTER_MODE;
export const clientName = process.env.CLIENT_NAME;
export const logsink = process.env.LOGSINK_URL;


export const validCallbacks = process.env.VALID_CALLBACKS
  .split(';')
  .map((url) => {
    const regexp = /^\/(.*)\/([^/]*$)/.exec(url);
    if (regexp) {
      return new RegExp(regexp[1], regexp[2]);
    }
    return url;
  });



// WEBPACK FOOTER //
// ./src/config/index.js